import React from 'react';
import { PaidCompletely, QuickSale } from '../../../../../types';
import { OrderEvent } from '../../../../../server-types';
import ArrowDown from '../ArrowDown';
import TimelineMilestone from './TimelineMilestone';
import OrderLineDetails from './OrderLineDetails';

const OrderPaidCompletely: React.FC<PaidCompletely | QuickSale> = props => {
    const { eventId, timestamp, details } = props;
    const paymentData = { 
        eventId,
        timestamp,
        details,
    };
    const orderClosedData = {
        eventId,
        timestamp,
        details: {
            changedBy: details.bill.issuedBy,
            place: details.bill.place,
        }
    };
    return (
        <>
            <OrderLineDetails eventType={OrderEvent.PaidPartially} {...paymentData} />
            <ArrowDown />
            <TimelineMilestone eventType={OrderEvent.PaidCompletely} {...orderClosedData} />
        </>
    );
};

export default OrderPaidCompletely;
